<template>
  <div class="position-relative">
    <b-row>
      <b-col md="6">
        <!-- <span v-if="checkPermission('all_access')"> -->

        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" v-b-toggle.sidebar-addNewRole>Add New
          Role</b-button>
        <!-- </span> -->
      </b-col>

      <b-col md="6">
        <b-row>
          <b-col md="8">
            <b-form-group   label-cols-sm="2" label-align-sm="right" label-size="md" label-for="filterInput">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group   label-cols-sm="4" label-align-sm="right" label-size="sm"
              label-for="perPageInput">
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                @change="savePerPage(perPage)" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-table
  v-if="roles.length > 0"
  :items="roles"
  :fields="fields"
  responsive="sm"
  :sticky-header="false"
  striped
  small
  id="role-table"
  :per-page="perPage"
  :current-page="currentPage"
  :filter="filter"
  :filter-included-fields="filterOn"
  @filtered="onFiltered"
>
      <template #cell(name)="row">
        <span>{{ row.item.name }}</span>
      </template>

      <template #cell(role)="row">
        <span>{{ row.item.roles[0].display_name }}</span>
      </template>
      <template #cell(permissions)="row">
        <p v-for="permission in row.item.permissions" :key="permission.id">{{ permission.name }}

        </p>
      </template>

      <!-- <template #cell(status)="row">
        <b-badge pill :variant="`light-${resolveUserStatusVariant(row.item.active)}`" class="text-capitalize">
          {{ resolveUserStatus(row.item.active) }}
        </b-badge>
      </template> -->

      <!-- <template #cell(date_created)="row">
        <span>{{ row.item.created_at | formatDate }}</span>
      </template> -->

      <template #cell(action)="row">
        <!-- <span v-if="checkPermission('all_access')"> -->

        <!-- <span v-if="row.item.active">
            <feather-icon icon="SlashIcon" size="16" class="text-body align-middle mr-25 cursor-pointer"
              v-b-tooltip.hover.v-danger title="Block User" @click="block_unblockUser(row.item.id, false)" />
          </span>

          <span v-if="!row.item.active">
            <feather-icon icon="UnlockIcon" size="16" class="text-body align-middle mr-25 cursor-pointer"
              v-b-tooltip.hover.v-warning title="Unblock User" @click="block_unblockUser(row.item.id, true)" />
          </span> -->

        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template v-slot:button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
          </template>
          <b-dropdown-item v-b-toggle.sidebar-editrole @click="sendRoleEditProps(row.item)">
            <feather-icon icon="Edit2Icon" class="mr-50" />
            <span>Edit</span>
          </b-dropdown-item>
          <b-dropdown-item @click="deleterole(row.item.id)">
            <feather-icon icon="TrashIcon" class="mr-50" />
            <span>Delete</span>
          </b-dropdown-item>
        </b-dropdown>
        <!-- </span> -->
      </template>
    </b-table>
    <div v-else class="text-center mt-4">{{ emptyRoleMessage }}</div>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" first-number last-number
      class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
      <template #prev-text>
        <feather-icon icon="ChevronLeftIcon" size="18" />
      </template>
      <template #next-text>
        <feather-icon icon="ChevronRightIcon" size="18" />
      </template>
    </b-pagination>

    <add-new-role @refresh="getAllRoles" />
    <edit-role :editRole="editRole" @refresh="getAllRoles" />

    <b-overlay :show="loader" no-wrap spinner-variant="primary"></b-overlay>
  </div>
</template>

<script>
import {
  BTable,
  BButton,
  VBToggle,
  BOverlay,
  BRow,
  BCol,
  BPagination,
  BFormGroup,
  BFormSelect,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BBadge,
  VBTooltip
} from "bootstrap-vue";
import axios from "axios";
import moment from "moment";
import Ripple from "vue-ripple-directive";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddNewRole from "./AddNewRole.vue";
import EditRole from "./EditRole.vue";
import { json } from "body-parser";
import User from '../../../Helpers/User'

export default {
  components: {
    BTable,
    BButton,
    BRow,
    BCol,
    BPagination,
    BOverlay,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BBadge,
    ToastificationContent,
    AddNewRole,
    EditRole
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      perPage: "25",
      pageOptions: [25, 50, 100, 200],
      currentPage: 1,
      emptyRoleMessage: "No Data Found.",
      totalRows: 1,
      filter: null,
      filterOn: [],
      fields: ["name", "display_name", "permissions", { key: "action", label: "Action", tdClass: 'actionClass' }],
      roles: [],
      loader: false,
      roleData: {},
      editRole: {}
    };
  },
  mounted() {
    this.perPage = this.getPerPage() ? this.getPerPage() : "25";
  },
  created() {
    this.getAllRoles();
  },

  methods: {
    checkPermission(permission) {

      return User.checkPermission(permission)
    },

    sendRoleEditProps(param) {
      this.editRole = param
    },
    // resolveUserStatus(status) {
    //   if (status == true) return 'active'
    //   if (status == false) return 'blocked'
    // },
    // resolveUserStatusVariant(status) {
    //   if (status == true) return 'success'
    //   if (status == false) return 'secondary'
    //   return 'primary'
    // },
    // resolveUserRoleIcon(role) {

    //   if (role === 'Manager') return 'Edit2Icon'
    //   if (role === 'Admin') return 'ServerIcon'
    //   return 'UserIcon'
    // },
    // resolveUserRoleVariant(role) {
    //   if (role === 'Manager') return 'warning'
    //   if (role === 'Admin') return 'danger'
    //   return 'primary'
    // },
    getAllRoles() {
      this.loader = true;
      axios
        .get(process.env.VUE_APP_API + "/roles")
        .then((res) => {
          this.loader = false;
          this.roles = res["data"];
        })
        .catch((error) => {
          this.loader = false;
          console.log(error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleterole(roleId) {
      if (roleId) {
        this.loader = true
        axios({
          method: 'post',
          url: process.env.VUE_APP_API + '/delete-role',
          data: {
            'roleId': roleId,
          }
        })
          .then((res) => {
            if (res.data.success) {
              this.getAllRoles()
              this.loader = false
              this.$toast
                ({
                  component: ToastificationContent,
                  props: {
                    title: 'Role Deleted',
                    icon: 'AlertOctagonIcon',
                    text: '',
                    variant: 'danger',
                  },
                },
                  {
                    position: 'top-right'
                  })
            }
            else {
              this.loader = false
              this.$toast
                ({
                  component: ToastificationContent,
                  props: {
                    title: 'Failed',
                    icon: 'AlertOctagonIcon',
                    text: '',
                    variant: 'danger',
                  },
                },
                  {
                    position: 'top-left'
                  })
            }
          })
          .catch((error) => {
            this.loader = false
            console.log(error);
          });

      }
    },
    rolepermission(roleId) {

    },
    // changeUserRole(roleId) {
    //   if (roleId) {
    //     this.loader = true
    //     axios({
    //       method: 'post',
    //       url: process.env.VUE_APP_API + '/change-user-role',
    //       data: {
    //         'roleId': roleId
    //       }
    //     })
    //       .then((res) => {
    //         if (res.data.success) {
    //           this.getAllRoles()
    //           this.loader = false
    //         }
    //         else {
    //           this.loader = false
    //           this.$toast
    //             ({
    //               component: ToastificationContent,
    //               props: {
    //                 title: 'Failed',
    //                 icon: 'AlertOctagonIcon',
    //                 text: res.data.message,
    //                 variant: 'danger',
    //               },
    //             },
    //               {
    //                 position: 'top-right'
    //               })
    //         }
    //       })
    //       .catch((error) => {
    //         this.loader = false
    //         console.log(error);
    //       });
    //   }

    // },
    // block_unblockUser(roleId, action) {

    //   if (roleId) {
    //     this.loader = true
    //     axios({
    //       method: 'post',
    //       url: process.env.VUE_APP_API + '/block-unblock-user',
    //       data: {
    //         'roleId': roleId,
    //         'action': action
    //       }
    //     })
    //       .then((res) => {
    //         if (res.data.success) {
    //           this.getAllRoles()
    //           this.loader = false
    //         }
    //         else {
    //           this.loader = false
    //           this.$toast
    //             ({
    //               component: ToastificationContent,
    //               props: {
    //                 title: 'Failed',
    //                 icon: 'AlertOctagonIcon',
    //                 text: '',
    //                 variant: 'danger',
    //               },
    //             },
    //               {
    //                 position: 'top-left'
    //               })
    //         }
    //       })
    //       .catch((error) => {
    //         this.loader = false
    //         console.log(error);
    //       });
    //   }

    // }
  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD , hh:mm:ss");
      }
    },
  },
  computed: {
    rows() {
      return this.roles.length;
    },
  }
};
</script>

<style>
.actionClass {
  max-width: 300px;
}
</style>